import store from '../vuex/store';
//按钮权限判断
const privilegesbtn = (btns) => {
  var show = false
  var newBtns = store.state.privilegescheck;
  if (newBtns.length==0||!newBtns) {
    var state = JSON.parse(sessionStorage.getItem("state"))
    newBtns = state.privilegescheck
  }
  if (newBtns && newBtns.length > 0) {
    newBtns.forEach(value => {
      if (value.button_id == btns) {
        show = true
      }
    })
  } else {
  }
  return show
}
export default privilegesbtn



// WEBPACK FOOTER //
// ./src/constant/privilegesbtn.js